export async function fetchExchangeRate(toCurrency) {
    if (toCurrency === 'GBP') return 1 // no conversion needed

    if (toCurrency === 'SAR') {
        return 5.18
    }

    const res = await fetch(`https://api.frankfurter.app/latest?from=GBP&to=${toCurrency}`)
    const data = await res.json()
    return data.rates[toCurrency]
}
